<template>
  <transition name="tran-detail">
    <div v-if="showDescription" class="description-area" >
      <h5 style="font-weight: 700; white-space: nowrap;overflow: hidden;" >
        {{ publicPageData.title }}
      </h5>
      <div class="description-space">
        <UserBlock :dtoUser="publicPageData.user"></UserBlock>
        <div style="margin-top: 0.5rem; margin-bottom: 0.5rem; white-space: pre;" >
          {{ publicPageData.description }}
        </div>
        <div style="display: flex;">
          <!-- todo:likeは一旦非表示
          <button
            @click="onLikeButton"
            id="likeButton"
            class="btn" style="padding-left: 0.5rem; display: flex;align-items: center;"
            :class="{
              'btn-primary': publicPageData.hasLoginUserGood,
              'btn-outline-primary': !publicPageData.hasLoginUserGood,
              'bg-white': !publicPageData.hasLoginUserGood,
              border: !publicPageData.hasLoginUserGood,
              'border-0': !publicPageData.hasLoginUserGood,
              'text-primary': !publicPageData.hasLoginUserGood,
            }"
            
          >
            <svg
              style="color: #666"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <use :xlink:href="urls.getIconURL('star')" />
            </svg>
            <span id="goodCount" style="padding-left: 0.25rem">
              {{ publicPageData.goodCount }}
            </span>
          </button>
          <div style="flex-grow: 1"></div>
          -->
          <!--/* todo:コメント数や再生数は一旦非表示。そのうち表示させる
          <div style="display: flex; align-items: center;" >
            <svg
              style="color: #666"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <use :xlink:href="urls.getIconURL('play')" />
            </svg>
            <span style="padding-left: 0.25rem">
              {{ publicPageData.viewCount }}
            </span>
          </div>
          <div style="padding-left: 1rem; display: flex; align-items: center;" >
            <svg
              style="color: #666"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <use :xlink:href="urls.getIconURL('chat')" />
            </svg>
            <span style="padding-left: 0.25rem">
              {{ publicPageData.commentsCount }}
            </span>
          </div>
          -->
        </div>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import RootVue from "@/RootVue.vue";
import PublicPageResp from '@/interface/api/PublicPageResp';
import UserBlock from "@/component/parts/UserBlock.vue";
import AnonymousBlock from "@/component/parts/AnonymousBlock.vue";
import urls from "@/URLs";

@Options({
  components: { UserBlock, AnonymousBlock },
  props: {
    showDescription: {
      type: Boolean,
    },
    publicPageData:{
      type:Object
    },

  },
})
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;
  readonly publicPageData!: PublicPageResp;
  readonly showDescription!: boolean;
  readonly urls = urls;
}
</script>

<style lang="scss" scoped>
.description-area{
  padding-left:8px;
  padding-bottom:8px;
  margin: auto;
}


.tran-detail-enter-active, .tran-detail-leave-active {
  transition: all 0.05s;
  *{
    transition: all 0.05s;
  }
}
.tran-detail-enter-to,
.tran-detail-leave-from
{
  opacity: 1;
}
.tran-detail-enter-from,
.tran-detail-leave-to {
  opacity: 0;
  line-height: 0;
  padding: 0;
  margin: 0;
  * {
    line-height: 0;
    padding: 0;
    margin: 0;
    transform: scaleY(0);
  }
}
</style>
